export type LoyaltyProgram = {
  id: string;
  pointsPerArs: number;
  redeemArsPerPoint: number;
  minRedeemPoints: number;
  isActive: boolean;
};

export type LoyaltyBalanceResult = {
  ok: boolean;
  balance: number;
  program: LoyaltyProgram | null;
  code?: string;
};

export type LoyaltyOrgSummary = {
  ok: boolean;
  earned: number;
  redeemed: number;
  liabilityPoints: number;
  accounts: number;
};

export type LoyaltyProgramInput = {
  id?: string | null;
  pointsPerArs: number;
  redeemArsPerPoint: number;
  minRedeemPoints: number;
  isActive: boolean;
  branchId: string;
  operationId: string;
};

/** ARS discount from points to redeem. */
export function redeemPointsToArs(points: number, redeemArsPerPoint: number): number {
  if (!Number.isFinite(points) || points <= 0) return 0;
  if (!Number.isFinite(redeemArsPerPoint) || redeemArsPerPoint <= 0) return 0;
  return Math.round(points * redeemArsPerPoint * 100) / 100;
}

/** Points earned from paid amount. */
export function earnPointsFromPaid(paidAmount: number, pointsPerArs: number): number {
  if (!Number.isFinite(paidAmount) || paidAmount <= 0) return 0;
  if (!Number.isFinite(pointsPerArs) || pointsPerArs <= 0) return 0;
  return Math.floor(paidAmount / pointsPerArs);
}
